export var getRootClasses = function (props, state) { return ({
    class: [
        // Display and Position
        'tw-inline-flex',
        'tw-relative',
        'tw-w-full',
        'tw-min-h-8',
        // Shape
        'tw-rounded-md',
        'tw-rounded-md',
        // Color and Background
        'tw-bg-white dark:tw-bg-gray-900',
        'tw-border dark:tw-border-gray-700',
        { 'tw-border-gray-300 dark:tw-border-gray-600': !props.invalid },
        // Invalid State
        'invalid:focus:tw-ring-red-200',
        'invalid:hover:tw-border-red-500',
        { 'tw-border-red-500 dark:tw-border-red-400': props.invalid },
        // Transitions (colors only — box-shadow excluded so the focus ring snaps in without animating)
        'tw-transition-colors',
        'tw-duration-200',
        // States
        { 'hover:tw-border-primary': !props.invalid },
        {
            'tw-outline-none tw-outline-offset-0 tw-ring-2 tw-ring-inset tw-ring-primary-300 dark:tw-ring-primary-300/50': state.focused,
        },
        // Misc
        'tw-font-sans tw-text-md',
        'tw-cursor-pointer',
        'tw-select-none',
        {
            'tw-opacity-60': props.disabled,
            'tw-pointer-events-none': props.disabled,
            'tw-cursor-default': props.disabled,
        },
    ],
}); };
export var DROPDOWN_CLASSES = [
    'tw-flex tw-items-center tw-justify-center',
    'tw-shrink-0',
    'tw-bg-transparent',
    'tw-text-gray-500',
    'tw-w-8',
    'tw-rounded-tr-md',
    'tw-rounded-br-md',
];
export var getOverlayClasses = function (isMobile) { return ({
    class: [
        'tw-absolute tw-top-0 tw-left-0',
        'tw-border-0 dark:tw-border',
        'tw-rounded-md',
        'tw-shadow-md',
        'tw-bg-white dark:tw-bg-gray-800',
        'tw-text-gray-800 dark:tw-text-white/80',
        'dark:tw-border-gray-700',
        {
            'tw-h-screen tw-w-screen !tw-max-h-none !tw-fixed !tw-inset-0 tw-bg-white dark:tw-bg-zinc-600 !tw-flex tw-flex-col': isMobile,
        },
        { 'tw-overflow-auto tw-rounded-md tw-max-w-min': !isMobile },
        { 'tw-border dark:tw-border-zinc-500 ': !isMobile },
    ],
}); };
export var getListContainerClasses = function (isMobile, filter) { return ({
    class: [
        'tw-max-h-[200px]',
        'tw-overflow-auto',
        { 'tw-shadow-lg': !isMobile },
        { 'tw-rounded-md': !isMobile && !filter },
        { '!tw-max-h-none': isMobile },
    ],
}); };
export var getHeaderClasses = function (isMobile, props) { return [
    'tw-px-3 tw-m-0',
    'tw-text-gray-700 dark:tw-text-white/80',
    'tw-border-b tw-border-gray-200 dark:tw-border-zinc-500',
    { 'tw-py-1.5': !props.filter },
    { 'tw-py-2': props.filter },
    'tw-bg-gray-100',
    { 'dark:tw-bg-zinc-600': !isMobile },
    { 'dark:tw-bg-zinc-700': isMobile },
]; };
export var getOptionClasses = function (context) { return [
    'tw-overflow-hidden',
    'tw-whitespace-nowrap',
    'tw-flex tw-items-center',
    'tw-relative',
    'tw-m-0',
    'tw-border-0 tw-rounded-none',
    'tw-text-md tw-font-sans tw-font-normal tw-leading-snug',
    { 'tw-pointer-events-none tw-cursor-default': context.disabled },
    { 'tw-cursor-pointer': !context.disabled },
]; };
export var LIST_CLASSES = 'tw-py-3 tw-list-none tw-m-0';
export var OPTION_CHECK_ICON_CLASSES = 'tw-relative tw--ms-1.5 tw-me-1.5 tw-text-gray-700 dark:tw-text-white/80 tw-w-4 tw-h-4';
export var OPTION_GROUP_CLASSES = [
    'tw-m-0 tw-px-3 tw-pt-3 tw-pb-1 tw-text-xs tw-tracking-wide tw-uppercase tw-text-gray-700 tw-font-bold',
    'tw-dark:tw-text-gray-300',
    'tw-cursor-auto',
];
export var OPTION_BLANK_ICON_CLASSES = 'tw-w-4 tw-h-4';
export var EMPTY_MESSAGE_CLASSES = [
    'tw-leading-none tw-font-sans',
    'tw-py-3 tw-px-5',
    'tw-text-gray-800 dark:tw-text-white/80',
    'tw-bg-transparent',
];
export var PC_FILTER_CONTAINER = { root: { class: 'tw-relative tw-w-full' } };
export var PC_FILTER = {
    root: [
        'tw-pr-3 tw-pl-8 tw--mr-8 tw-py-1.5',
        'tw-w-full',
        'tw-font-sans tw-text-base tw-border tw-transition tw-duration-200 tw-rounded-lg tw-appearance-none',
        'tw-text-gray-700 tw-bg-white tw-border-gray-300 hover:tw-border-gray-400',
        'dark:tw-bg-zinc-500 dark:tw-border-zinc-400 dark:hover:tw-border-zinc-300 dark:tw-text-white',
        'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring-0 focus-visible:tw-border-primary-500 dark:tw-focus-visible:tw-border-primary-500',
    ],
};
export var PC_FILTER_ICON_CONTAINER = { root: { class: 'tw--mt-2 tw-left-0.5 tw-absolute tw-top-1/2 tw-ml-2 !tw-w-4 !tw-h-4' } };
export var TRANSITION_CLASSES = {
    enterFromClass: 'tw-opacity-0 tw-scale-y-[0.8]',
    enterActiveClass: 'tw-transition-[transform,opacity] tw-duration-[120ms] tw-ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'tw-transition-opacity tw-duration-100 tw-ease-linear',
    leaveToClass: 'tw-opacity-0',
};
